const ProductCodes = {
    PAY_PER_LEAD: 'PAY_PER_LEAD',
    PAY_PER_CLICK: 'PAY_PER_CLICK',
    FLAT_FEE: 'FLAT_FEE',
    FLAT_FEE_FEED_CONNECT: 'FLAT_FEE_FEED_CONNECT',
    PAY_PER_LEASE: 'PAY_PER_LEASE',
    INTEGRATED_PAY_PER_LEASE: 'INTEGRATED_PAY_PER_LEASE',
    CONCIERGE_PAY_PER_LEASE: 'CONCIERGE_PAY_PER_LEASE',
    SINGLE_FAMILY: 'SINGLE_FAMILY',
    SINGLE_FAMILY_DAILY_LISTINGS: 'SINGLE_FAMILY_DAILY_LISTINGS',
    BASE_PACKAGE: 'BASE_PACKAGE',
    ENHANCED_PACKAGE: 'ENHANCED_PACKAGE',
    PREMIUM_PACKAGE: 'PREMIUM_PACKAGE',
    PREMIUM_PLUS_PACKAGE: 'PREMIUM_PLUS_PACKAGE',
};

const ProductTypes = {
    [ProductCodes.PAY_PER_LEAD]: 'Zillow Rent Connect™',
    [ProductCodes.PAY_PER_CLICK]: 'Zillow Rent Connect™',
    [ProductCodes.FLAT_FEE]: 'Zillow Rent Connect™',
    [ProductCodes.FLAT_FEE_FEED_CONNECT]: 'Zillow Feed Connect™',
    [ProductCodes.PAY_PER_LEASE]: 'Zillow Lease Connect™',
    [ProductCodes.INTEGRATED_PAY_PER_LEASE]: 'Zillow Lease Connect™',
    [ProductCodes.CONCIERGE_PAY_PER_LEASE]: 'Zillow Lease Connect™',
    [ProductCodes.SINGLE_FAMILY]: 'Pay Per Listing',
    [ProductCodes.SINGLE_FAMILY_DAILY_LISTINGS]: 'Zillow Feed Connect™',
    [ProductCodes.BASE_PACKAGE]: 'Zillow Rent Connect™ Base',
    [ProductCodes.ENHANCED_PACKAGE]: 'Zillow Rent Connect™ Enhanced',
    [ProductCodes.PREMIUM_PACKAGE]: 'Zillow Rent Connect™ Premium',
    [ProductCodes.PREMIUM_PLUS_PACKAGE]: 'Zillow Rent Connect™ Premium Plus',
};

const PackageTypes = new Set([
    ProductCodes.BASE_PACKAGE,
    ProductCodes.ENHANCED_PACKAGE,
    ProductCodes.PREMIUM_PACKAGE,
    ProductCodes.PREMIUM_PLUS_PACKAGE,
]);

const FlatFeeTypes = new Set([...PackageTypes, ProductCodes.FLAT_FEE, ProductCodes.FLAT_FEE_FEED_CONNECT]);

const PackagePlatforms = {
    [ProductTypes.BASE_PACKAGE]: 'Z+T+HP',
    [ProductTypes.ENHANCED_PACKAGE]: 'Z+T+HP',
    [ProductTypes.PREMIUM_PACKAGE]: 'Z+T+HP+FB+IG',
    [ProductTypes.PREMIUM_PLUS_PACKAGE]: 'Z+T+HP+FB+IG',
};

const AdproductsConstants = {
    ProductTypes,
    PackagePlatforms,
    ProductCodes,
    PackageTypes,
    FlatFeeTypes,
};

export default AdproductsConstants;
